import { IInitialState } from "@/interfaces/config";

export const handleDeleteCampaign = (state: IInitialState, action) => {
    state.campaigns = state.campaigns.filter(campaing => campaing._id !== action.payload)
}